import { Routes } from '@angular/router';
import { authGuard, loginGuard } from '@okcargo-apps/guards-ionic';
import { AppTab, CRUD_USERS_CAPABILITIES, ECapabilities } from '@okcargo-apps/shared-domain-ionic';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layout/pages/tabs/tabs.routes').then((m) => m.routes),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: `tabs/${AppTab.FINISHED}/:id`,
    loadComponent: () =>
      import('./layout/pages/freight-finished-detail/freight-finished-detail.page').then(
        (m) => m.FreightFinishedDetailPage,
      ),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: `tabs/${AppTab.IN_PROGRESS}/:id`,
    loadComponent: () =>
      import('./layout/pages/freight-inprogress-detail/freight-inprogress-detail.page').then(
        (m) => m.FreightInprogressDetailPage,
      ),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: `tabs/${AppTab.FREIGHT_AVAILABLE}/:id`,
    loadComponent: () =>
      import('./layout/pages/freight-available-detail/freight-available-detail.page').then(
        (m) => m.FreightAvailableDetailPage,
      ),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.VIEW_MARKET },
  },
  // Legacy redirect: keep old /tabs/market/:id URLs working
  {
    path: `tabs/market/:id`,
    redirectTo: `/tabs/${AppTab.FREIGHT_AVAILABLE}/:id`,
  },
  {
    path: 'account',
    loadComponent: () => import('./layout/pages/account/account.page').then((m) => m.AccountPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'account/account-preferences',
    loadComponent: () =>
      import('./layout/pages/account-preferences/account-preferences.page').then((m) => m.AccountPreferencesPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'account/password',
    loadComponent: () => import('./layout/pages/password/password.page').then((m) => m.PasswordPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'my-company',
    loadComponent: () => import('./layout/pages/my-company/my-company.page').then((m) => m.MyCompanyPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.ADMINISTRATIVE_DOCUMENTS },
  },
  {
    path: 'posted-freight',
    loadComponent: () => import('./layout/pages/freight-posted/freight-posted.page').then((m) => m.FreightPostedPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.UPLOAD_FREIGHTS },
  },
  {
    path: 'posted-freight/ship-new',
    loadComponent: () =>
      import('./layout/pages/freight-ship-new/freight-ship-new.page').then((m) => m.FreightShipNewPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.UPLOAD_FREIGHTS },
  },
  {
    path: 'posted-freight/ship-edit/:id',
    loadComponent: () =>
      import('./layout/pages/freight-ship-edit/freight-ship-edit.page').then((m) => m.FreightShipEditPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.UPLOAD_FREIGHTS },
  },
  {
    path: 'posted-freight/:id',
    loadComponent: () =>
      import('./layout/pages/freight-posted-detail/freight-posted-detail.page').then((m) => m.FreightPostedDetailPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.UPLOAD_FREIGHTS },
  },
  {
    path: 'vehicles',
    loadComponent: () => import('./layout/pages/vehicles/vehicles.page').then((m) => m.VehiclesPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.CRUD_VEHICLES },
  },
  // Legacy redirect: keep old /plates URLs working
  {
    path: 'plates',
    redirectTo: '/vehicles',
    pathMatch: 'full',
  },
  {
    path: 'users',
    loadComponent: () => import('./layout/pages/users/users.page').then((m) => m.UsersPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [...CRUD_USERS_CAPABILITIES] },
  },
  {
    path: 'deca-new',
    loadComponent: () => import('./layout/pages/deca-new/deca-new.page').then((m) => m.DecaNewPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.CREATE_DECA_AS_CARRIER, ECapabilities.CREATE_DECA_AS_SHIPPER] },
  },
  {
    path: 'deca-new/:id',
    loadComponent: () => import('./layout/pages/deca-new/deca-new.page').then((m) => m.DecaNewPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.CREATE_DECA_AS_CARRIER, ECapabilities.CREATE_DECA_AS_SHIPPER] },
  },
  {
    path: 'deca-transfer/:id',
    loadComponent: () => import('./layout/pages/deca-new/deca-new.page').then((m) => m.DecaNewPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.CREATE_DECA_AS_SHIPPER, docMode: 'transfer' },
  },
  {
    path: 'deca',
    loadComponent: () => import('./layout/pages/deca-list/deca-list.page').then((m) => m.DecaListPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.VIEW_DECA_AS_CARRIER, ECapabilities.VIEW_DECA_AS_SHIPPER] },
  },
  {
    path: 'deca-detail/:id',
    loadComponent: () => import('./layout/pages/deca-detail/deca-detail.page').then((m) => m.DecaDetailPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.VIEW_DECA_AS_CARRIER, ECapabilities.VIEW_DECA_AS_SHIPPER] },
  },
  {
    path: 'deca-edit/:id',
    loadComponent: () => import('./layout/pages/deca-edit/deca-edit.page').then((m) => m.DecaEditPage),
    canActivate: [authGuard],
    data: { requiredCapabilities: [ECapabilities.CREATE_DECA_AS_CARRIER, ECapabilities.CREATE_DECA_AS_SHIPPER] },
  },
  {
    path: 'help',
    loadComponent: () => import('./layout/pages/help/help.page').then((m) => m.HelpPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'support',
    loadComponent: () => import('./layout/pages/support/support.page').then((m) => m.SupportPage),
    canActivate: [authGuard],
    data: { requiredCapability: ECapabilities.AUTHENTICATED },
  },
  {
    path: 'login',
    loadComponent: () => import('./layout/pages/login/login.page').then((m) => m.LoginPage),
    canActivate: [loginGuard],
  },
  {
    path: 'recover-password',
    loadComponent: () =>
      import('./layout/pages/recover-password/recover-password.page').then((m) => m.RecoverPasswordPage),
    canActivate: [loginGuard],
  },
  {
    path: 'recover-password-confirm',
    loadComponent: () =>
      import('./layout/pages/recover-password-confirm/recover-password-confirm.page').then(
        (m) => m.RecoverPasswordConfirmPage,
      ),
    canActivate: [loginGuard],
  },
  {
    path: 'registration',
    loadComponent: () => import('./layout/pages/registration/registration.page').then((m) => m.RegistrationPage),
    canActivate: [loginGuard],
  },
  {
    path: 'error',
    loadComponent: () => import('./layout/pages/error/error.page').then((m) => m.ErrorPage),
  },
  {
    path: 'update-required',
    loadComponent: () =>
      import('./layout/pages/update-required/update-required.page').then((m) => m.UpdateRequiredPage),
  },
  // catch all
  { path: '**', redirectTo: '/', pathMatch: 'full' },
];
